import {DefaultValue, selector, selectorFamily} from 'recoil';

import {
  currentTaskLocationCodeState,
  currentTaskLocationState,
  taskLocationsDictQueryByCodeTrigger,
  taskLocationsMapWithNamesState,
  taskLocationsDictQueryTrigger,
  taskLocationsState,
} from './atoms';

import {DictionaryService} from '../../api/services/dictionary.service';

export const taskLocationsDictQuery = selector({
  key: 'taskLocationsDictQuery',
  get: async ({get}) => {
    get(taskLocationsDictQueryTrigger);
    const res = await DictionaryService.getAllTaskLocations();

    return res.data;
  },

  set: ({set, get}, newValue) => {
    if (newValue) {
      set(taskLocationsState, newValue);

      if (newValue && !(newValue instanceof DefaultValue) && newValue.content?.length > 0) {
        const mapWithNames = get(taskLocationsMapWithNamesState);

        newValue.content.forEach((i) => {
          mapWithNames.set(i.code, i.name);
          mapWithNames.set(i.name?.toLowerCase(), i.code);
        });
      }
    }
  },
});

export const taskLocationDictQueryByCode = selector({
  key: 'taskLocationDictQueryByCode',
  get: async ({get}) => {
    const code = get(currentTaskLocationCodeState);

    if (!code) return null;

    const res = await DictionaryService.getTaskLocationByCode(String(code));

    return res.data;
  },

  set: ({set}, newValue) => {
    set(currentTaskLocationState, newValue);
  },
});

export const taskLocationDictQueryByCodeFamily = selectorFamily({
  key: 'taskLocationDictQueryByCodeFamily',
  get:
    (code) =>
    async ({get}) => {
      get(taskLocationsDictQueryByCodeTrigger);

      const res = await DictionaryService.getTaskLocationByCode(String(code));

      return res.data;
    },

  set:
    (code) =>
    ({set}, newValue) => {
      set(currentTaskLocationState, newValue);
    },
});

export const taskLocationMapWithNamesSelector = selector({
  key: 'taskLocationMapWithNamesSelector',
  get: ({get}) => {
    const {content: taskLocations} = get(taskLocationsState);

    const mapWithNames = new Map<string, string>();

    taskLocations.length > 0 &&
      taskLocations.forEach((i) => {
        mapWithNames.set(i.code, i.name);
      });

    return mapWithNames;
  },
});
